export const rentalDetails: { id: string; name: string }[] = [
  { id: '24hr-checkin', name: $localize`24 Hour Check-in` },
  { id: 'activities_older_children', name: $localize`Activities Older Children` },
  { id: 'activities_young_children', name: $localize`Activities Young Children` },
  { id: 'adjoining_rooms', name: $localize`Adjoining Rooms` },
  { id: 'all_inclusive', name: $localize`All Inclusive` },
  { id: 'bathtub', name: $localize`Bathtub` },
  { id: 'bbq', name: $localize`BBQ/Picnic area` },
  { id: 'beach', name: $localize`Beach` },
  { id: 'beach_view', name: $localize`Beach View` },
  { id: 'beachfront', name: $localize`Beach Front` },
  { id: 'bed_and_breakfast', name: $localize`Bed And Breakfast` },
  { id: 'bicycle', name: $localize`Bicycle` },
  { id: 'breakfast', name: $localize`Breakfast` },
  { id: 'business_services', name: $localize`Business Services` },
  { id: 'cable', name: $localize`Cable Television` },
  { id: 'car_rental', name: 'Car Rental' },
  { id: 'central_air_conditioning', name: $localize`Air Conditioning` },
  { id: 'concierge', name: $localize`Concierge` },
  { id: 'credit_cards_accepted', name: $localize`Credit Cards Accepted` },
  { id: 'desk', name: $localize`Desk` },
  { id: 'dishwasher', name: $localize`Dishwasher` },
  { id: 'doorman', name: $localize`Doorman` },
  { id: 'dry_cleaning', name: $localize`Dry Cleaning` },
  { id: 'dryer', name: $localize`Dryer` },
  { id: 'early_arrival', name: $localize`Early Arrival` },
  { id: 'elder_access', name: $localize`Elder Access` },
  { id: 'fireplace', name: $localize`Indoor Fireplace` },
  { id: 'fitness_center', name: $localize`Fitness Center` },
  { id: 'free_breakfast', name: $localize`Free Breakfast` },
  { id: 'free_cancelation', name: $localize`Free Cancelation` },
  { id: 'free_housekeeping', name: $localize`Free Housekeeping` },
  { id: 'free_internet', name: $localize`Free Internet` },
  { id: 'free_local_calls', name: $localize`Free Local Calls` },
  { id: 'free_parking', name: $localize`Free Parking` },
  { id: 'free_wifi', name: $localize`Free Wifi` },
  { id: 'freezer', name: $localize`Freezer` },
  { id: 'game_room', name: $localize`Game Room` },
  { id: 'games', name: $localize`Games` },
  { id: 'garden', name: $localize`Garden` },
  { id: 'gym', name: $localize`Gym` },
  { id: 'hair-dryer', name: $localize`Hair Dryer` },
  { id: 'hangers', name: $localize`Hangers` },
  { id: 'heating', name: $localize`Heating` },
  { id: 'hot_tub', name: $localize`Hot Tub` },
  { id: 'housekeeping', name: $localize`Housekeeping` },
  { id: 'indoor_pool', name: $localize`Indoor pool` },
  { id: 'inperson_checkin', name: $localize`In-Person check-in` },
  { id: 'iron', name: $localize`Clothes Iron` },
  { id: 'iron_board', name: $localize`Ironing Board` },
  { id: 'kids_activities', name: $localize`Kids Activities` },
  { id: 'late_arrival', name: $localize`Late Arrival` },
  { id: 'late_check_out', name: $localize`Late Check Out` },
  { id: 'lockers_storage', name: $localize`Lockers Storage` },
  { id: 'loyalty_rewards_available', name: $localize`Loyalty Rewards Available` },
  { id: 'massage', name: $localize`Massage` },
  { id: 'meals_included', name: $localize`Meals Included` },
  { id: 'meeting_room', name: $localize`Meeting Room` },
  { id: 'non_smoking', name: $localize`Non Smoking` },
  { id: 'paid_parking', name: $localize`Paid Parking` },
  { id: 'parking_available', name: $localize`Parking Available` },
  { id: 'patio_furniture', name: $localize`Outdoor furniture` },
  { id: 'pets_allowed', name: $localize`Pets Allowed` },
  { id: 'private_beach', name: $localize`Private beach area` },
  { id: 'room_service', name: $localize`Room Service` },
  { id: 'room_with_a_view', name: $localize`Room With A View` },
  { id: 'shampoo', name: $localize`Shampoo` },
  { id: 'shared_dryer', name: $localize`Shared Dryer` },
  { id: 'shared_washers', name: $localize`Shared Washers` },
  { id: 'shuttle', name: $localize`Shuttle` },
  { id: 'smart_tv', name: $localize`Smart TV` },
  { id: 'smartlock', name: $localize`Smartlock` },
  { id: 'stairs_elevator', name: $localize`Stairs Elevator` },
  { id: 'stroller_parking', name: $localize`Stroller Parking` },
  { id: 'swimming_pool', name: $localize`Swimming Pool` },
  { id: 'television', name: $localize`Television` },
  { id: 'tennis_court', name: $localize`Tennis Court` },
  { id: 'terrace', name: $localize`Terrace` },
  { id: 'valet_parking', name: $localize`Valet Parking` },
  { id: 'washer', name: $localize`Washer` },
  { id: 'water_sports', name: $localize`Water Sports` },
  { id: 'water_view', name: $localize`Water View` },
  { id: 'waterfront', name: $localize`Waterfront` },
  { id: 'wheelchair_access', name: $localize`Wheelchair Access` },
  { id: 'fridge', name: $localize`Fridge` },
  { id: 'bath', name: $localize`Bath` },
  { id: 'shower', name: $localize`Shower` },
  { id: 'washing_machine', name: $localize`Washing Machine` },
  { id: 'coffee_maker', name: $localize`Coffee Maker` },
  { id: 'baby_cot', name: $localize`Baby Cot` },
  { id: 'high_chair', name: $localize`High Chair` },
  { id: 'smoke_alarms', name: $localize`Smoke Alarms` },
  { id: 'dedicated_workspace', name: $localize`Dedicated Workspace` },
  { id: 'microwave', name: $localize`Microwave` },
  { id: 'outdoor_dining_area', name: $localize`Outdoor Dining Area` },
  { id: 'lift', name: $localize`Lift` },
  { id: 'downtown', name: $localize`Downtown` },
  { id: 'golf_course_front', name: $localize`Golf Course Front` },
  { id: 'golf_course_view', name: $localize`Golf Course View` },
  { id: 'lake', name: $localize`Lake` },
  { id: 'lake_front', name: $localize`Lake Front` },
  { id: 'lake_view', name: $localize`Lake View` },
  { id: 'near_ocean', name: $localize`Near Ocean` },
  { id: 'ocean_front', name: $localize`Ocean Front` },
  { id: 'ocean_view', name: $localize`Ocean View` },
  { id: 'resort', name: $localize`Resort` },
  { id: 'river', name: $localize`River` },
  { id: 'rural', name: $localize`Rural` },
  { id: 'ski_in', name: $localize`Ski In` },
  { id: 'ski_in_out', name: $localize`Ski In Out` },
  { id: 'ski_out', name: $localize`Ski Out` },
  { id: 'town', name: $localize`Town` },
  { id: 'village', name: $localize`Village` },
  { id: 'mountain', name: $localize`Mountain` },
  { id: 'mountain_view', name: $localize`Mountain view` },
].sort((a, b) => a.name.localeCompare(b.name))

export const rentalLocales: { id: string; name: string }[] = [
  { id: 'aa', name: 'Afar' },
  { id: 'ab', name: 'Abkhazian' },
  { id: 'ae', name: 'Avestan' },
  { id: 'af', name: 'Afrikaans' },
  { id: 'ak', name: 'Akan' },
  { id: 'am', name: 'Amharic' },
  { id: 'an', name: 'Aragonese' },
  { id: 'ar', name: 'Arabic' },
  { id: 'as', name: 'Assamese' },
  { id: 'av', name: 'Avaric' },
  { id: 'ay', name: 'Aymara' },
  { id: 'az', name: 'Azerbaijani' },
  { id: 'ba', name: 'Bashkir' },
  { id: 'be', name: 'Belarusian' },
  { id: 'bg', name: 'Bulgarian' },
  { id: 'bh', name: 'Bihari languages' },
  { id: 'bi', name: 'Bislama' },
  { id: 'bm', name: 'Bambara' },
  { id: 'bn', name: 'Bengali' },
  { id: 'bo', name: 'Tibetan' },
  { id: 'br', name: 'Breton' },
  { id: 'bs', name: 'Bosnian' },
  { id: 'ca', name: 'Catalan; Valencian' },
  { id: 'ce', name: 'Chechen' },
  { id: 'ch', name: 'Chamorro' },
  { id: 'co', name: 'Corsican' },
  { id: 'cr', name: 'Cree' },
  { id: 'cs', name: 'Czech' },
  { id: 'cu', name: 'Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic' },
  { id: 'cv', name: 'Chuvash' },
  { id: 'cy', name: 'Welsh' },
  { id: 'da', name: 'Danish' },
  { id: 'de', name: 'German' },
  { id: 'dv', name: 'Divehi; Dhivehi; Maldivian' },
  { id: 'dz', name: 'Dzongkha' },
  { id: 'ee', name: 'Ewe' },
  { id: 'el', name: 'Greek, Modern (1453-)' },
  { id: 'en', name: 'English' },
  { id: 'eo', name: 'Esperanto' },
  { id: 'es', name: 'Spanish; Castilian' },
  { id: 'et', name: 'Estonian' },
  { id: 'eu', name: 'Basque' },
  { id: 'fa', name: 'Persian' },
  { id: 'ff', name: 'Fulah' },
  { id: 'fi', name: 'Finnish' },
  { id: 'fj', name: 'Fijian' },
  { id: 'fo', name: 'Faroese' },
  { id: 'fr', name: 'French' },
  { id: 'fy', name: 'Western Frisian' },
  { id: 'ga', name: 'Irish' },
  { id: 'gd', name: 'Gaelic; Scottish Gaelic' },
  { id: 'gl', name: 'Galician' },
  { id: 'gn', name: 'Guarani' },
  { id: 'gu', name: 'Gujarati' },
  { id: 'gv', name: 'Manx' },
  { id: 'ha', name: 'Hausa' },
  { id: 'he', name: 'Hebrew' },
  { id: 'hi', name: 'Hindi' },
  { id: 'ho', name: 'Hiri Motu' },
  { id: 'hr', name: 'Croatian' },
  { id: 'ht', name: 'Haitian; Haitian Creole' },
  { id: 'hu', name: 'Hungarian' },
  { id: 'hy', name: 'Armenian' },
  { id: 'hz', name: 'Herero' },
  { id: 'ia', name: 'Interlingua (International Auxiliary Language Association)' },
  { id: 'id', name: 'Indonesian' },
  { id: 'ie', name: 'Interlingue; Occidental' },
  { id: 'ig', name: 'Igbo' },
  { id: 'ii', name: 'Sichuan Yi; Nuosu' },
  { id: 'ik', name: 'Inupiaq' },
  { id: 'io', name: 'Ido' },
  { id: 'is', name: 'Icelandic' },
  { id: 'it', name: 'Italian' },
  { id: 'iu', name: 'Inuktitut' },
  { id: 'ja', name: 'Japanese' },
  { id: 'jv', name: 'Javanese' },
  { id: 'ka', name: 'Georgian' },
  { id: 'kg', name: 'Kongo' },
  { id: 'ki', name: 'Kikuyu; Gikuyu' },
  { id: 'kj', name: 'Kuanyama; Kwanyama' },
  { id: 'kk', name: 'Kazakh' },
  { id: 'kl', name: 'Kalaallisut; Greenlandic' },
  { id: 'km', name: 'Central Khmer' },
  { id: 'kn', name: 'Kannada' },
  { id: 'ko', name: 'Korean' },
  { id: 'kr', name: 'Kanuri' },
  { id: 'ks', name: 'Kashmiri' },
  { id: 'ku', name: 'Kurdish' },
  { id: 'kv', name: 'Komi' },
  { id: 'kw', name: 'Cornish' },
  { id: 'ky', name: 'Kirghiz; Kyrgyz' },
  { id: 'la', name: 'Latin' },
  { id: 'lb', name: 'Luxembourgish; Letzeburgesch' },
  { id: 'lg', name: 'Ganda' },
  { id: 'li', name: 'Limburgan; Limburger; Limburgish' },
  { id: 'ln', name: 'Lingala' },
  { id: 'lo', name: 'Lao' },
  { id: 'lt', name: 'Lithuanian' },
  { id: 'lu', name: 'Luba-Katanga' },
  { id: 'lv', name: 'Latvian' },
  { id: 'mg', name: 'Malagasy' },
  { id: 'mh', name: 'Marshallese' },
  { id: 'mi', name: 'Maori' },
  { id: 'mk', name: 'Macedonian' },
  { id: 'ml', name: 'Malayalam' },
  { id: 'mn', name: 'Mongolian' },
  { id: 'mr', name: 'Marathi' },
  { id: 'ms', name: 'Malay' },
  { id: 'mt', name: 'Maltese' },
  { id: 'my', name: 'Burmese' },
  { id: 'na', name: 'Nauru' },
  { id: 'nb', name: 'Bokmål, Norwegian; Norwegian Bokmål' },
  { id: 'nd', name: 'Ndebele, North; North Ndebele' },
  { id: 'ne', name: 'Nepali' },
  { id: 'ng', name: 'Ndonga' },
  { id: 'nl', name: 'Dutch; Flemish' },
  { id: 'nn', name: 'Norwegian Nynorsk; Nynorsk, Norwegian' },
  { id: 'no', name: 'Norwegian' },
  { id: 'nr', name: 'Ndebele, South; South Ndebele' },
  { id: 'nv', name: 'Navajo; Navaho' },
  { id: 'ny', name: 'Chichewa; Chewa; Nyanja' },
  { id: 'oc', name: 'Occitan (post 1500); Provençal' },
  { id: 'oj', name: 'Ojibwa' },
  { id: 'om', name: 'Oromo' },
  { id: 'or', name: 'Oriya' },
  { id: 'os', name: 'Ossetian; Ossetic' },
  { id: 'pa', name: 'Panjabi; Punjabi' },
  { id: 'pi', name: 'Pali' },
  { id: 'pl', name: 'Polish' },
  { id: 'ps', name: 'Pushto; Pashto' },
  { id: 'pt', name: 'Portuguese' },
  { id: 'qu', name: 'Quechua' },
  { id: 'rm', name: 'Romansh' },
  { id: 'rn', name: 'Rundi' },
  { id: 'ro', name: 'Romanian; Moldavian; Moldovan' },
  { id: 'ru', name: 'Russian' },
  { id: 'rw', name: 'Kinyarwanda' },
  { id: 'sa', name: 'Sanskrit' },
  { id: 'sc', name: 'Sardinian' },
  { id: 'sd', name: 'Sindhi' },
  { id: 'se', name: 'Northern Sami' },
  { id: 'sg', name: 'Sango' },
  { id: 'si', name: 'Sinhala; Sinhalese' },
  { id: 'sk', name: 'Slovak' },
  { id: 'sl', name: 'Slovenian' },
  { id: 'sm', name: 'Samoan' },
  { id: 'sn', name: 'Shona' },
  { id: 'so', name: 'Somali' },
  { id: 'sq', name: 'Albanian' },
  { id: 'sr', name: 'Serbian' },
  { id: 'ss', name: 'Swati' },
  { id: 'st', name: 'Sotho, Southern' },
  { id: 'su', name: 'Sundanese' },
  { id: 'sv', name: 'Swedish' },
  { id: 'sw', name: 'Swahili' },
  { id: 'ta', name: 'Tamil' },
  { id: 'te', name: 'Telugu' },
  { id: 'tg', name: 'Tajik' },
  { id: 'th', name: 'Thai' },
  { id: 'ti', name: 'Tigrinya' },
  { id: 'tk', name: 'Turkmen' },
  { id: 'tl', name: 'Tagalog' },
  { id: 'tn', name: 'Tswana' },
  { id: 'to', name: 'Tonga (Tonga Islands)' },
  { id: 'tr', name: 'Turkish' },
  { id: 'ts', name: 'Tsonga' },
  { id: 'tt', name: 'Tatar' },
  { id: 'tw', name: 'Twi' },
  { id: 'ty', name: 'Tahitian' },
  { id: 'ug', name: 'Uighur; Uyghur' },
  { id: 'uk', name: 'Ukrainian' },
  { id: 'ur', name: 'Urdu' },
  { id: 'uz', name: 'Uzbek' },
  { id: 've', name: 'Venda' },
  { id: 'vi', name: 'Vietnamese' },
  { id: 'vo', name: 'Volapük' },
  { id: 'wa', name: 'Walloon' },
  { id: 'wo', name: 'Wolof' },
  { id: 'xh', name: 'Xhosa' },
  { id: 'yi', name: 'Yiddish' },
  { id: 'yo', name: 'Yoruba' },
  { id: 'za', name: 'Zhuang; Chuang' },
  { id: 'zh', name: 'Chinese' },
  { id: 'zu', name: 'Zulu' },
]
